import i18n from '../../../../locales/index'
import Fullscreen from './fullscreen.vue'
export default Fullscreen
